"use client";

const Error = () => {
	return <>error</>;
};

export default Error;
